import { TimePeriod } from '../../../enum/time-period.enum';
import { Address } from '../../../interface/address.inteface';

export class CreateOrderItemDto {
  /** Recipient account. Defaults to the billing (request) account when omitted. */
  organisation?: string;
  plan_id: string;
}

export class CreateOrderDto {
  /** true → razorpay_subscription; false → razorpay. */
  isAutoRenew?: boolean;
  /** One plan per recipient account. All items share `period`. */
  items: CreateOrderItemDto[];
  period: TimePeriod;
  billingName: string;
  billingAddress: Address;
  gstin?: string;
}
